export default "__VITE_ASSET__58291e95__"